import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import CustomDialog from 'widgets/component/CustomDialog';
import DataTableDetailOrder from 'widgets/customDialogComponentDetails/ComponentDialog';
import { CircularProgressStyle } from '../list-transactions-netpay/style/style';

const NetPayDetailsDialog = ({
  open,
  onClose,
  loading,
  detailTransactionsNetpay,
  handleOpenPopUp,
  setOpenActionFraud,
  setIdReverso,
  setActiveAction,
  setShouldReturnData,
  activeAction,
  shouldReturnData,
}) => {
  return (
    <CustomDialog
      fullWidth
      title={
        detailTransactionsNetpay?.response?.payment_info === null
          ? 'No hay datos'
          : 'Transacción netpay'
      }
      content={
        loading ? (
          <CircularProgress sx={CircularProgressStyle.CircularProgress} />
        ) : (
          <DataTableDetailOrder
            type='detailsNetPay'
            handleOpenPopUp={handleOpenPopUp}
            setOpenActionFraud={setOpenActionFraud}
            response={detailTransactionsNetpay?.response}
            idTransaction={detailTransactionsNetpay?.response?.transaction_type?.transaction_id}
            onClose={onClose}
            setIdReverso={setIdReverso}
            setActiveAction={setActiveAction}
            setShouldReturnData={setShouldReturnData}
            activeAction={activeAction}
            shouldReturnData={shouldReturnData}
          />
        )
      }
      open={open}
      onClose={onClose}
      maxWidth='md'
      extraButtons={[
        {
          label: 'Aceptar',
          variant: 'contained',
          onClick: onClose,
          buttonColor: 'purple',
          textColor: 'white',
        },
      ]}
    />
  );
};

export default NetPayDetailsDialog;
